'use strict';
module.exports = require('./Avatar.vue');